import React from 'react';
import LogToolbar from './LogToolbar';

export default function LogConversionsToolbar(props) {
    return <LogToolbar {...props} kind="conversions"/>;
}
